@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;

.invoice-form {

	&__status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-draft"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-design-gray6;
			}
		}
	}

	&__contact-dropdown-item {
		display: flex;
		flex-direction: column;

		&__main {
			font-size: Constants.$val-fontSizeRegular;
		}

		&__secondary {
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-greyFontLight;
		}
	}

	&__submit-section {
		display: flex;
		align-items: center;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 1px solid #C5C8CB;
		top: $var-submit-action-top-offset;
		position: sticky;

		&__invoice-code-and-reminder {
			font-size: Constants.$val-fontSizeBig;
			font-weight: bold;
			flex: 1;
			display: flex;

			&__code {
				padding-right: Constants.$val-spacing-l;
				align-content: center;
			}
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
		z-index: 3;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__form {
			background-color: #FAFAFA;			

			&__section {
				background-color: Colors.$col-white;
				box-shadow: $var-shadow;
				padding: Constants.$val-spacing-m Constants.$val-spacing-l;
				margin-top: Constants.$val-spacing-m;
				margin-bottom: Constants.$val-spacing-m;
				margin-left: Constants.$val-spacing-s;
				margin-right: Constants.$val-spacing-s;
	
				&__title {
					text-transform: uppercase;
					color: Colors.$col-design-gray5;
					font-size: Constants.$val-fontSizeSmall;
					margin-bottom: Constants.$val-spacing-m;
				}
	
				&__installment-notice {
					font-style: italic;
					color: Colors.$col-design-gray5;
					margin-bottom: Constants.$val-spacing-m;
				}
	
				&__row {
					display: grid;
					gap: 64px;
					grid-template-columns: repeat(24, 1fr);
	
					&__column-date {
						grid-column: span 6;
						margin-right: 128px;
					}
	
					&__column-note {
						grid-column: span 21;
					}
	
					&__column-payment-info {
						grid-column: span 4;
						margin-right: 64px;
					}
	
					&__column-id {
						grid-column: span 6;
						margin-right: 64px;
					}
	
					&__column-1 {
						grid-column: span 1;
					}
	
					&__column-2 {
						grid-column: span 2;
					}
	
					&__column-4 {
						grid-column: span 4;
					}
	
					&__column-6 {
						grid-column: span 6;
					}
	
					&__column-8 {
						grid-column: span 8;
					}
	
					&__centered-column {
						display: flex;
						align-items: center;
					}
				}
			}
		}

	}

	&__delete-button {
		margin-top: Constants.$val-spacing-m;

		& > [class^="icon-delete"] {
			color: Colors.$col-grey;
			font-size: Constants.$val-fontSizeBig;
			cursor: pointer;
			margin-top: calc(Constants.$val-spacing-l + Constants.$val-spacing-s);

			&:hover {
				color: Colors.$col-black;
			}
		}
	}

	&__radio-group {
		padding-bottom: Constants.$val-spacing-m;
	}

	&__tab {
		display: flex;
		gap: Constants.$val-spacing-xs;
		align-items: center;

		& > [class^="icon-warning"] {
			color: Colors.$col-canceledRed;
			font-size: Constants.$val-fontSizeBig;

		}
	}

	&__add-field-button {
		width: fit-content;
		color: Colors.$col-blue;
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-top: Constants.$val-spacing-m;

		& [class^="icon-plus"] {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
		}
		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}

}


.buttonActions {
	display: flex;
	& > * + * {
		margin-left: Constants.$val-spacing-xs;
	}
}